<template>
  <div class="accordion-block">
    <h2 class="accordion-title">{{ title }}</h2>
    <div class="accordion">
      <div class="acc-item"
        v-for="(item, accordionIndex) in content"
        :key="item.title"
        :class="{ 'acc-item--expanded': expandedStatus[accordionIndex] }"
      >
        <div class="acc-header" @click="toggleAccordion(accordionIndex)">
          <span class="acc-title">{{ item.title }}</span>
          <span class="acc-actions">
            <svg class="acc-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M6 9l6 6 6-6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </div>
        <div class="acc-panel">
          <ul class="test-list">
            <li class="test-row" v-for="test in item.items" :key="test.name">
              <div>
                <div class="test-name">{{ test.name }}</div>
                <div class="test-desc">{{ test.description }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoAccordion',
  props: {
    title: String,
    content: Array
  },
  data: () => ({
    expandedStatus: []
  }),
  created() {
    this.expandedStatus = this.content.map(() => false)
  },
  methods: {
    toggleAccordion(index) {
      this.$set(this.expandedStatus, index, !this.expandedStatus[index])
    },
  }
}
</script>

<style lang="scss" scoped>
.accordion-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.accordion-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.accordion {
  display: grid;
  gap: 12px;
}

.acc-item {
  background: #fff;
  border: 1px solid #e3f0ea;
  border-radius: 10px;
  overflow: hidden;

  &--expanded {
    .acc-chevron {
      transform: rotate(180deg);
    }
  }
}

.acc-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #eef7f4;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #e6f3ef;
  }
}

.acc-title {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #207868;
  font-weight: 700;
  font-size: 16px;
}

.acc-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.acc-chevron {
  width: 18px;
  height: 18px;
  transition: transform 0.25s ease;
}

.acc-panel {
  background: #fff;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-height 0.28s ease, opacity 0.28s ease;
  padding: 0 20px;
}

.acc-item--expanded .acc-panel {
  opacity: 1;
  max-height: 800px;
}

.test-list {
  list-style: none;
  padding: 10px 0;
  margin: 0;
}

.test-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid #f2f6f5;

  &:last-child {
    border-bottom: 0;
  }

  .test-name {
    font-weight: 600;
    color: #2a6f63;
    line-height: 1.4;
  }

  .test-desc {
    font-size: 13px;
    color: #6c7d77;
    margin-top: 4px;
  }
}
</style>
